module.exports = __webpack_public_path__ + "static/image/history/pc/202204.jpg?f92b9f03";